<template>
  <div class="m-list">
    <div class="width-a">
      <h1 class="title">精英采访</h1>
      <ul class="content">
        <li class="toolsb">
          <el-input class="mb-input" placeholder="请输入学员姓名" v-model="interviewTitle"></el-input>
          <el-button type="primary" @click="toQuery">搜索</el-button>
          <el-button type="primary" @click="resetQuery">重置</el-button>
        </li>
        <template v-for="(item, index) in tableData">
          <li class="c-item" :key="item.interviewId" @click="detailTap(index)">
            <div class="left">
              <img v-if="item.imgUrl" :src="item.imgUrl | fileFilter" alt="">
              <img v-else :src="require('@/assets/default.png')" alt="">
            </div>
            <div class="right">
              <h2 class="ci-title">{{item.introduce}}</h2>
              <div class="ci-info">- {{item.interviewTitle}}</div>
            </div>
          </li>
        </template>
      </ul>
      <el-pagination class="ma-pagination" :current-page="curPage" layout="total, prev, pager, next" :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
  import HttpConnectionC from "@/utils/HttpConnectionC";
  import CommonFilters from "@/mixins/CommonFilters";
  export default {
    name: "Interviews",
    mixins: [CommonFilters],
    data () {
      return {
        interviewTitle: "",
        tableData: [],
        curPage: 1,
        total: 0
      };
    },
    mounted () {
      let that = this;
      that.queryData();
    },
    methods: {
      queryData () {
        let that = this;
        HttpConnectionC.get("/homepage/listInterview", {
          params: {
            interviewTitle: that.interviewTitle,
            pageNum: that.curPage,
            pageSize: 10
          }
        }).then(function (response) {
          that.tableData = response.rows;
          that.total = response.total;
        });
      },
      handleCurrentChange (val) {
        this.curPage = val;
        this.queryData();
      },
      detailTap (index) {
        let _id = this.tableData[index].interviewId;
        this.$router.push({
          path: "/InterviewsDetail?interviewId=" + _id
        });
      },
      toQuery () {
        this.curPage = 1;
        this.queryData();
      },
      resetQuery () {
        this.interviewTitle = "";
        this.curPage = 1;
        this.queryData();
      }
    }
  };
</script>

<style scoped lang="scss">
  .m-list {
    background-image: url("../assets/bga01.png");
    background-repeat: no-repeat;
  }

  .title {
    font-size: 36px;
    font-weight: normal;
    color: #ffffff;
    text-align: center;
    padding: 60px 0px 40px 0px;
  }

  .content {
    padding: 60px 60px 0px 60px;
    margin-top: 60px;
    background-color: #ffffff;
  }

  .c-item {
    display: flex;
    flex-direction: row;
    padding: 32px;
    border: solid 1px #e3e4e5;
    margin: 0px 0px 30px 0px;
    cursor: pointer;
  }

  .left {
    width: 240px;
    height: 160px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .right {
    flex: 1;
    padding: 10px 40px 10px 40px;
  }

  .ci-title {
    height: 100px;
    font-size: 16px;
    color: #666666;
    line-height: 24px;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .ci-info {
    text-align: right;
    color: #333333;
    font-size: 20px;
    margin-top: 20px;
  }
</style>